var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStoreDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6032",
    "data-name": "Group 6032",
    transform: "translate(-1041 -304)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Delivery",
    transform: "translate(1059 322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7174",
    "data-name": "Path 7174",
    d: "M94.881,220v17.085a7.119,7.119,0,0,1-7.119,7.119H67.119A7.119,7.119,0,0,1,60,237.085V220",
    transform: "translate(-36.441 -182.203)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7175",
    "data-name": "Path 7175",
    d: "M223.119,140v10.678l-3.559-3.559L216,150.678V140",
    transform: "translate(-178.559 -109.322)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x2: 4,
    transform: "translate(31 55)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7173",
    "data-name": "Path 7173",
    d: "M58.441,30.678H23.559A3.559,3.559,0,0,1,20,27.119V23.559A3.559,3.559,0,0,1,23.559,20H58.441A3.559,3.559,0,0,1,62,23.559v3.559A3.559,3.559,0,0,1,58.441,30.678Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStoreDetails);
export default __webpack_public_path__ + "static/media/EmptyStoreDetails.27cb8724abbb69f448e8804b50a548cf.svg";
export { ForwardRef as ReactComponent };